export default __webpack_public_path__ + "static/media/webpack.cf92f221.svg";